import { render, staticRenderFns } from "./profile-contact-info.vue?vue&type=template&id=3b91b675&scoped=true"
import script from "./profile-contact-info.vue?vue&type=script&lang=js"
export * from "./profile-contact-info.vue?vue&type=script&lang=js"
import style0 from "./profile-contact-info.vue?vue&type=style&index=0&id=3b91b675&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b91b675",
  null
  
)

export default component.exports